module.exports = __webpack_public_path__ + "static/media/repayments.b5492bba.svg";